import { fxConfig } from './config';

/** HANDOFF: light per reel stop, medium on win, heavy on crash / big win, double for big win / level up. */
export type HapticKind = 'light' | 'medium' | 'heavy' | 'double';

const PATTERN: Record<HapticKind, number | number[]> = {
  light: 10,
  medium: 25,
  heavy: 45,
  double: [22, 60, 22],
};

/**
 * Chrome blocks (and logs "Blocked call to navigator.vibrate") any vibration before the first user
 * gesture — e.g. a Liftoff round crashing right after the page loads. Skip until there was one.
 */
function hasUserActivation(): boolean {
  const ua = navigator.userActivation;
  // browsers without the API (Safari < 16.4) have no vibrate either; allow and let try/catch cover it
  return ua ? ua.hasBeenActive : true;
}

export function haptic(kind: HapticKind): void {
  if (!fxConfig.haptics) return;
  try {
    if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
    if (!hasUserActivation()) return;
    navigator.vibrate(PATTERN[kind]);
  } catch {
    /* not supported (iOS) */
  }
}
